<template>
   
        <div class="mb-md-4 main">

            <div class="d-flex align-items-center mb-2 label_box">
                <label class="mb-0">{{ label }}</label>
            </div>
           
            <div v-if="loader && alphaOptions.length == 0" class="skeleton"></div>

            <div v-else class="drop_block" :class="{ 'invalid': mode }" v-click-outside="() => showOptions = false">
                
                <div class="current_active" @click="showOptions = !showOptions">

                    <div class="d-flex align-items-center">

                        <span v-if="detailData?.alphabets">{{ detailData?.alphabets }}</span>
                        
                    </div>

                    <SvgHeaderSvg v-if="!showOptions" :type="'down'" />
                    <SvgHeaderSvg v-else :type="'up'" />

                </div>

                <ul class="p-0" v-show="showOptions">

                    <li v-for="(list, index) in alphaOptions" :key="index" @click="toggleOption(list)" :class="{ 'active': list?.alphabets === detailData?.alphabets }">

                        <span>{{ list.alphabets }}</span>

                    </li>

                </ul>

            </div>

            <div class="error_boxx" v-if="mode">{{ mode.join(" ") }}</div>

        </div>
</template>

<script setup>
import { ClickOutsideDirective as vClickOutside } from '@/directives/ClickOutsideDirective';

import { shopdetailStore } from '@/stores/shop_detail/shop_detail';

const store = shopdetailStore()
const route = useRoute();

const { type, label, mode, attr } = defineProps(['type', 'label', 'mode', 'attr'])

const router = useRouter()

const showOptions = ref(false)
const loader = ref(true)
const localePath = useLocalePath();

const detailData = computed(() => {
    return store.getDetailData
})

const currentMetal = computed(() => {
    return store.getCurrentActive('metal')
})

const alphabetOptions = ref([]);

const fetchAlphabets = async () => {
    loader.value = true;
    try {
        const res = await $fetch(useCountryPath('/config/shop/list/dropdown?sub_type=initial-necklace'), {
            method: 'GET',
        });

        if (res?.success) {
            alphabetOptions.value = res.data;
            loader.value = false;
        }
    }
    catch (error) {
        console.log('Error Fetching Initial Necklace DropDown', error);
    }
    finally {
        // cleaningLoader.value = false;
    }
};

const alphaOptions = computed(() => {
   
    const activeMetal = currentMetal.value?.value;

    if(!activeMetal) return [];
    
    const filtered = alphabetOptions.value.filter(item => item.metal === activeMetal)
       
    return filtered;
   
});


const toggleOption = (options) => {
    if (options?.full_slug) {
        const path = localePath(options?.full_slug)
        window.location.href = path
        // router.push({ path, query: { 'refreshKey': options.alphabets } });
    }
};

onMounted(() => {
    fetchAlphabets()
})
</script>

<style scoped>
 .skeleton {
        height: 42px;
        border-radius: 8px;
        background: #eaeaea;
        min-width: 85px;
    }
.skeleton {
    height: 42px;
    border-radius: 8px;
    background: #eaeaea;
    min-width: 85px;
}

.current_active .svg-head {
    height: 12px;
    width: 20px;
}

p {
    font-size: 12px;
    font-weight: 600;
}

p a {
    color: var(--green);
}

.drop_block.invalid .current_active {
    border: 1px solid rgb(255, 2, 2);
}

.drop_block li:hover {
    background: #eaeaea;
}

.label_box {
    font-size: 14px;
    font-weight: 600;
    text-transform: capitalize;
    color: #212529;
}

.label_box div {
    color: rgb(159, 158, 158);
    cursor: pointer;
}

label {
    color: #303030;
    font-size: 16px;
    font-weight: 600;
}

.drop_block {
    position: relative;
}

.current_active {
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 1.5;
    color: #000;
    vertical-align: middle;
    border: 1px solid #c4c4c4;
    padding: 0 10px;
    font-size: 14px;
    cursor: pointer;
    height: 44px;
    border-radius: 8px;
}


.current_active.focused {
    border-color: var(--green);
    box-shadow: 0 0 0 0.2rem rgb(112 192 153 / 25%);
}

ul {
    border: 1px solid #c4c4c4;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #fff;
    z-index: 9;
    padding: 10px 0;
    max-height: 210px;
    overflow: auto;
    border-radius: 8px;
}

ul li {
    list-style: none;
    padding: 5px 10px;
    cursor: pointer;
    display: flex;
    align-items: center;
    text-transform: capitalize;
}

ul li.active {
    background: rgba(204, 204, 204, 0.36863);
}

ul li.disabled {
    opacity: 0.4;
    pointer-events: none;
}

span {
    font-weight: 400;
    font-size: 14px;
    color: #212529;
    text-transform: capitalize;
}

@media(max-width:768px) {
    .main {
        padding: 20px 0px;
    }

    label {
        font-size: 14px;
    }
}
</style>
